import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {CommonService} from './common.service';
import {map} from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
// import { of } from 'rxjs';

const routes = {
  filterTest: `/contract/filter`,
  filter: `/digital-certificate/filter`,
  viewDetail: (id: string, idDetail: string) => `/digital-certificate/view/${id}/${idDetail}`,
  viewSyncDetail: (id: string, idDetail: string) => `/digital-certificate/synchronize-cert-cloud-ca/${id}/${idDetail}`,
  add: () => `/digital-certificate/create`,
  changeStatus: (id: string) => `/digital-certificate/change-status/${id}`,
  getCertificates: (id: string, signLot?: boolean) => `/digital-certificate/get-certificate/${id}?signLot=${signLot}`,
  addCertificateHsm: () => `/hsm/hsm-generate-csr`,
  generateTransaction: (phone: string) => `/digital-certificate/otp/generate-transaction/${phone}`,
  confirmOtp: () => `/digital-certificate/otp/confirm`,
  registerOtp: () => `/digital-certificate/create`,
  checkStatusCertificateHsm: () => `/hsm/check-certificate-status`,
  checkStatusCertificateSignuaterServer: (id: string) => `/digital-certificate/check-signature-server/${id}`,
  getListCertificateSimCA: (enterpriseId: string, phone: string) => `/digital-certificate/get-certificate-simca/${enterpriseId}/${phone}`,
  getListCertCloudCa: () => `/digital-certificate/get-cert-cloud-ca`,
  getListCertVNEID: () => `/digital-certificate/get-cert-vneid`,
  getInformCertificateFromFile: () => `/digital-certificate/get-certificate-usbtoken`,
  getListPhoneOtp: () => `/digital-certificate/get-phone-otp`,
  getCertificatesWithType: (typeCer: number) => `/digital-certificate/get-certificate-by-type/${typeCer}`,
  getServerCertificatesWithSigner: (typeCer: string) => `/digital-certificate/get-server-certificate-by-signer/${typeCer}`,
  getCertificatesTypeRegistered: () => `/digital-certificate/get-type-certificate`,
  downloadSignPlugin(os ?: string) {
    // console.log(os)
     let OSName="Unknown OS";
    if(typeof(os) != 'undefined') {
      OSName = os;
    }
    else{
    if (navigator.appVersion.indexOf("Win")!=-1) OSName="WINDOWS";
    if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MACOS";
    if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
    if (navigator.appVersion.indexOf("Linux")!=-1) OSName="LINUX";
    }


    const path =  `/file/download-last-version?os=${OSName}&typeFile=${OSName === "WINDOWS" ? 'exe' : OSName === "LINUX" ? 'deb' : 'pkg'}`;
    return path;
  },
  downloadSignPluginByOS: (os: String) => {
    const path =  `/file/download-last-version?os=${os}&typeFile=${os === "WINDOWS" ? 'exe' :os === "LINUX" ? 'deb' : 'pkg'}`;
    return path;
  },
  getSignPluginName: () => `/file/sign-plugin-name`,
  updateImageCertificate: () => `/digital-certificate/update-image`,
  uploadImageCertificate: () => `/file/upload/image-certificate`,
  getUserNameAndFullName: (name: string) => `/users/getUserNameAndFullName/${name}`,
  updateListUserManager: () => `/digital-certificate/update-users-manager`,
  getServiceTypeByContractId: (contractId: string, role: string) => `/auto-sign/getServiceTypeByContractId/${contractId}?role=${role}`,
  changeConfirmRenewCertificateStatus: (certificateId: string, serialNumber: string) => `/digital-certificate/update-confirm-renew-date/${certificateId}/${serialNumber}`,
  filterDefault: `/digital-certificate/default/filter`,
  addDefault: () => `/digital-certificate/update-certificate-default`,
  changeDefaultStatus: () => `/digital-certificate/change-default-status`,
  checkHsmPermission: '/digital-certificate/check-hsm-enterprise',
  getPermissionHSM: (id: string) => `/enterprises/configs/${id}`,
  //Đồng bộ
  filterSync: '/digital-certificate/get-all-sync',
  syncServiceType: '/digital-certificate/sync',
  endSessionCloudCaDate:()=> `/digital-signature/cloud-ca-transaction-check`,
  deleteSessionCloudCa:()=> `/digital-signature/cloud-ca-delete-extension`,
  saveSessionCloudCa:()=> `/digital-signature/cloud-ca-register-extension`,
  getDurationCloudCa:()=> `/digital-signature/cloud-ca-extend-config`,
  getListCertEasyCa: () => `/digital-certificate/get-cert-easy-sign`,
  updatePin: ()=> `/digital-certificate/update-pin`,
  changeSyncMySign: (isSync: boolean, id: string) => `/digital-certificate/change-sync?isSync=${isSync}&digitalCertificateId=${id}`,
  signTindy : ()=> `/tindy/users/messages/authenticate`,
  authenticateTindyProgress : ()=> `/tindy/messages/authenticate/progress`
};

/**
 * Phone prefix
 */
enum PhonePrefix {
  VN = '84'
}

@Injectable({
  providedIn: 'root'
})
export class DigitalCertificateService {

  constructor(private apiService: ApiService, private commonService: CommonService) {
  }

  /**
   * Search list document type for enterprise
   */
  searchDigitalCertificate(filter: any) {
    return this.apiService.postSilently(routes.filter, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  viewDigitalCertificateDetail(id: string, idDetail: string) {
    return this.apiService.get(routes.viewDetail(id, idDetail));
  }

  /**
   * get sync certificate
   */
  viewSyncDigitalCertificateDetail(id: string, idDetail: string) {
    return this.apiService.get(routes.viewSyncDetail(id, idDetail));
  }

  /**
   * Change status
   */
  changeStatus(id: string) {
    return this.apiService.get(routes.changeStatus(id));
  }

  /**
   * Add certificate
   */
  add(obj: object) {
    return this.apiService.post(routes.add(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  updateImageCertificate(obj: object) {
    return this.apiService.postFormData(routes.updateImageCertificate(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Upload file for certificate with formdata
   */
  uploadFile(file: File) {
    const formdata = new FormData();

    formdata.append('file', file);

    return this.apiService.postUpload('/file/upload/certificate/', formdata)
      .pipe(map(res => {
        return res;
      }));
  }

  uploadFileImage(file: File) {
    const formData = new FormData();
    formData.append('image', file);
    return this.apiService.postUpload(routes.uploadImageCertificate(), formData)
      .pipe(map(res => {
        return res;
      }));
  }
  uploadFileImage2(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postUpload(routes.uploadImageCertificate(), formData)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Version Base64 cua updateImageCertificate - anh chung thu gui JSON thay multipart binary.
   */
  updateImageCertificateBase64 = async (obj: any) => {
    const body = {...obj};
    const image = body.image;
    delete body.image;
    // Khong gui field "image": BE decode no thanh file ten "image" khong co extension,
    // lam NfsServiceImpl.createFileName crash (substring(0, lastIndexOf('.')) = -1).
    // Gui "base64Image" + "imageName" de BE dung Base64FileUtils.toMultipartFile voi ten file that.
    delete body.base64Image;
    delete body.imageName;
    if (image instanceof Blob) {
      const file = image as File;
      body.base64Image = await this.commonService.getFileBase64(file);
      body.imageName = file.name || 'image.png';
    }
    return this.apiService.postFileBase64(routes.updateImageCertificate(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  /**
   * Version Base64 cua uploadFileImage2 - anh chung thu gui JSON thay multipart binary.
   */
  uploadFileImageBase64 = async (file: File) => {
    const fileBase64 = await this.commonService.getFileBase64(file);
    return this.apiService.postFileBase64(routes.uploadImageCertificate(), {files: [{fileName: file.name, file: fileBase64}]})
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  /**
   * Cập nhật riêng cấu hình ảnh ký mặc định của phương thức ký (PYC-84222 task 3).
   * Tái sử dụng API update-image/base64: BE nhận thêm 3 field optional
   * defaultSignImageType (0 hệ thống / 1 upload / 2 vẽ), defaultSignConfig (JSON),
   * drawSignImageBase64 (ảnh vẽ) — không truyền thì giữ nguyên cấu hình cũ.
   */
  updateDefaultSignImage(obj: object) {
    return this.apiService.postFileBase64(routes.updateImageCertificate(), obj)
      .pipe(map(res => {
        return res;
      }));
  }
  /**
   * Get list certificate
   */
   checkHsmPermission() {
    return this.apiService.get(routes.checkHsmPermission)
      .pipe(map(res => {
        return res;
      }));
  }

  getPermissionHSM(id: string) {
    return this.apiService.get(routes.getPermissionHSM(id)).pipe(
      map(data => data
      )
    );
  }

  getCertificates(id: string, signLot?: boolean) {
    return this.apiService.get(routes.getCertificates(id, signLot))
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Add certificate
   */
  addCertificateHsm(obj: object) {
    return this.apiService.post(routes.addCertificateHsm(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Generate Transaction for register OTP
   * @param phone numberphone register OTP
   */
  generateTransaction(phone: string) {
    return this.apiService.get(routes.generateTransaction(phone));
  }

  /**
   * Confirm register OTP
   */
  confirmOtp(obj: object) {
    return this.apiService.post(routes.confirmOtp(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Register OTP
   */
  registerOtp(obj: object) {
    return this.apiService.post(routes.registerOtp(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Check status of certificate HSM
   */
  checkStatusCertificateHsm(obj: object) {
    return this.apiService.post(routes.checkStatusCertificateHsm(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Check status of certificate signuater server
   */
  checkStatusCertificateSignuaterServer(enterpriseId: string) {
    return this.apiService.get(routes.checkStatusCertificateSignuaterServer(enterpriseId));
  }

  /**
   * Get list certificate of sim CA
   * @param numberphone numberphone of sim CA need get list certificate
   */
  getListCertificateSimCA(enterpriseId: string, numberphone: string) {
    return this.apiService.get(routes.getListCertificateSimCA(enterpriseId, numberphone));
  }

  getListCertCloudCa(enterpriseId: string, userName: string, providerName: string) {
    const data = {
      enterpriseId: enterpriseId,
      cloudCaUsername: userName,
      providerName: providerName
    };
    return this.apiService.post(routes.getListCertCloudCa(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  getListCertVNEID(enterpriseId: string, userName: string) {
    const data = {
      enterpriseId: enterpriseId,
      citizenPid: userName
    };
    return this.apiService.post(routes.getListCertVNEID(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Get inform certificate of file
   * @param base64Cert string base64 of file upload
   */
  getInformCertificateFromFile(obj: object) {
    return this.apiService.post(routes.getInformCertificateFromFile(), obj);
  }


  /**
   * Add prefix
   */
  public formatPhoneNumber(phoneNumber: string) {
    if (phoneNumber) {
      if (phoneNumber.startsWith('84')) {
        return phoneNumber;
      }
      return phoneNumber.startsWith('0')
        ? `${PhonePrefix.VN}${phoneNumber.substr(1)}`
        : `${PhonePrefix.VN}${phoneNumber}`;
    } else {
      return '';
    }
  }

  /**
   * Get list phone register otp for sign otp
   */
  getListPhoneOtp() {
    return this.apiService.get(routes.getListPhoneOtp());
  }

  /**
   * Get list certificate
   */
  getCertificatesWithType(typeCer: number) {
    return this.apiService.get(routes.getCertificatesWithType(typeCer));
  }

  /**
   * Get list server certificate with signer
   */
  getServerCertificatesWithSigner(signerId: string) {
    return this.apiService.get(routes.getServerCertificatesWithSigner(signerId));
  }

  /**
   * Get list certificate
   */
  getCertificatesTypeRegistered() {
    return this.apiService.get(routes.getCertificatesTypeRegistered());
  }

  /**
   * Download sign plugin
   */
  downloadSignPlugin(os?: string) {
    return this.apiService.getFile(routes.downloadSignPlugin(os))
      .pipe(map(res => {
        console.log("acb", res);
        return res;
      }));
  }

  linkDownloadPluginSign(os ?: string){
    return this.apiService.BASE_URL + routes.downloadSignPlugin(os);
  }

  /**
   * Download sign plugin
   */
  getSignPluginName(os ?: string): string {
    console.log("os" ,os);
    let osName = os;
    if(typeof(os) == 'undefined') {
    if (navigator.appVersion.indexOf("Win")!=-1) osName="WINDOWS";
    if (navigator.appVersion.indexOf("Mac")!=-1) osName="MACOS";
    if (navigator.appVersion.indexOf("X11")!=-1) osName="UNIX";
    if (navigator.appVersion.indexOf("Linux")!=-1) osName="LINUX";
    }

    console.log("osName " ,osName);


    if(osName === "WINDOWS"){
      return "Hop dong dien tu.exe";
    }
    else if (osName === "LINUX" ) {
      return "Hop dong dien tu.deb"
    }
    else if (osName === "MACOS" ) {
      return "Hop dong dien tu.pkg"
    }

  }

  getUserNameAndFullName(name: string) {
    return this.apiService.get(routes.getUserNameAndFullName(name)).pipe(map(res => {
      return res;
    }));
  }

  updateListUserManager(obj: object) {
    return this.apiService.post(routes.updateListUserManager(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  getServiceTypeByContractId(contractId: string, role?: string) {
    return this.apiService.get(routes.getServiceTypeByContractId(contractId, role))
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Change confirm send warning status
   */
  changeConfirmRenewCertificateStatus(certificateId: string, serialNumber: string) {
    return this.apiService.get(routes.changeConfirmRenewCertificateStatus(certificateId, serialNumber))
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Search list document type for user
   */
  searchDigitalCertificateDefault(filter: any) {
    return this.apiService.post(routes.filterDefault, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Add certificate
   */
  addDefault(obj: object) {
    return this.apiService.post(routes.addDefault(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  changeDefaultStatus(obj: object) {
    return this.apiService.post(routes.changeDefaultStatus(), obj)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Get list service type sync
   * @param filter
   * @returns
   */
  filterSyncDigitalCertificates(filter: any) {
    return this.apiService.post(routes.filterSync, filter)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sync service type
   */
   syncDigitalCertificates(data: any) {
    return this.apiService.post(routes.syncServiceType, data)
      .pipe(map(res => {
        return res;
      }));
  }
  endSessionCloudCa(body: any) {
    return this.apiService.post(routes.endSessionCloudCaDate(),body)
      .pipe(map(res => {
      return res;
    }));
  }
  deleteSessionCloudCa(body: any){
    return this.apiService.post(routes.deleteSessionCloudCa(),body)
      .pipe(map(res => {
      return res;
    }));
  }
  saveSessionCloudCa(body: any){
    return this.apiService.post(routes.saveSessionCloudCa(),body)
      .pipe(map(res => {
      return res;
    }));
  }
  getDurationCloudCa(body: any){
    return this.apiService.post(routes.getDurationCloudCa(),body)
      .pipe(map(res => {
      return res;
    }));
  }

  getListCertEasyCa(enterpriseId: string, serial: string, pin: string) {
    const data = {
      enterpriseId: enterpriseId,
      serial: serial,
      pin: pin
    };
    return this.apiService.post(routes.getListCertEasyCa(), data)
      .pipe(map(res => {
        return res;
    }));
  }

  updatePin(body: any){
    return this.apiService.post(routes.updatePin(), body)
      .pipe(map(res => {
        return res;
    }));
  }

  changeSyncMysign(isSync: boolean, id: any){
    return this.apiService.get(routes.changeSyncMySign(isSync,id))
      .pipe(map(res => {
        return res;
    }));
  }

  signTindyAuthen(body: any){
    return this.apiService.post(routes.signTindy(), body)
      .pipe(map(res => {
        return res;
    }));
  }

  getTindyAuthenticateProgress(sessionId: string) {
  const params = new HttpParams().set('sessionId', sessionId);

  return this.apiService.get(routes.authenticateTindyProgress(), params)
    .pipe(map(res => {
      return res;
    }));
}

}
